import React from 'react';
import { Calculator } from '../../components';

function Condicoes() {
  return (
    <>
      <h1>Calculadora</h1>
      <p>Esta calculadora permite estimar qual será o valor mensal da prestação e o valor total do empréstimo. Para tanto escolha o valor total do empréstimo, número de parcelas para quitação e dia do mês do pagamento das mensalidades.
      </p>
      <Calculator hideTextInfo />
    </>
  )
}

export default Condicoes;